import React from 'react';
import { useTheme } from '../contexts/ThemeContext';
import { useVariant } from '../contexts/VariantContext';
import { usePageTitle } from '../hooks/usePageTitle';

const Privacy = () => {
  const { brand, domainConfig } = useTheme();
  const { styles } = useVariant();
  
  // Get hostname-specific H1 title, fallback to domainConfig
  const h1Title = usePageTitle('privacy');
  
  // Build fallback title from domainConfig
  const fallbackTitle = domainConfig?.seo?.pages?.privacy?.title 
    || `${domainConfig?.name || brand?.name || 'Privacy'} Privacy Policy`;

  return (
    <div className={`min-h-screen pt-24 pb-12 ${styles.container}`}>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-12">
          <h1 className={`text-4xl font-bold ${styles.text} mb-4`}>
            {h1Title || fallbackTitle}
          </h1>
          <p className={`text-lg ${styles.textSecondary}`}>
            Last updated: {new Date().toLocaleDateString('en-US', { 
              year: 'numeric', 
              month: 'long', 
              day: 'numeric' 
            })}
          </p>
        </div>

        {/* Content */}
        <div className={`rounded-2xl shadow-lg overflow-hidden ${styles.card}`}>
          <div className="p-8 md:p-12">
            <div className={`prose prose-lg max-w-none ${styles.text}`}>

              {/* Information We Collect */}
              <section className="mb-8">
                <h2 className={`text-2xl font-bold ${styles.text} mb-4`}>1. Information We Collect</h2>
                <p className={`${styles.textSecondary} leading-relaxed mb-4`}>
                  We collect information you provide directly to us, such as when you create an account, use our services, 
                  or contact us for support. This may include:
                </p>
                <ul className={`list-disc pl-6 ${styles.textSecondary} space-y-2`}>
                  <li>Personal information (name, email address, phone number, etc...)</li>
                  <li>We only collect information that you voluntarily provide.</li>
                  <li>We do not collect information from your devices.</li>
                  <li>We do not share your information with third parties.</li>
                  <li>We do not use cookies or similar technologies.</li>
                </ul>
              </section>

              {/* How We Use Information */}
              <section className="mb-8">
                <h2 className={`text-2xl font-bold ${styles.text} mb-4`}>2. How We Use Your Information</h2>
                <p className={`${styles.textSecondary} leading-relaxed mb-4`}>
                  We use the information we collect to:
                </p>
                <ul className={`list-disc pl-6 ${styles.textSecondary} space-y-2`}>
                  <li>Contact you regarding your inquiries or service requests.</li>
                  <li>We do not use your information for any other purpose.</li>
                </ul>
              </section>

              {/* Information Sharing */}
              <section className="mb-8">
                <h2 className={`text-2xl font-bold ${styles.text} mb-4`}>3. Information Sharing and Disclosure</h2>
                <p className={`${styles.textSecondary} leading-relaxed mb-4`}>
                  We do not sell, trade, or otherwise transfer your personal information to third parties except in the following circumstances:
                </p>
                <ul className={`list-disc pl-6 ${styles.textSecondary} space-y-2`}>
                  <li>With your explicit consent</li>
                  <li>To comply with legal obligations or court orders.</li>
                  <li>To protect our rights, property, or safety.</li>
                </ul>
              </section>

            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Privacy;
